import React from 'react';
import ContentArea from "../components/content-area/Content";
import ComingSoonPage from "../components/homepage/ComingSoonPage";
import AiModerationIconPng from "../assets/icons/aimoderation.png";

const AIModeration = () => (
  <ContentArea title="AI Moderation" icon={AiModerationIconPng} container={false}>
    <ComingSoonPage />
  </ContentArea>
);

export default AIModeration;
